import axios from 'axios'
import publish from './pubilshSet'
import connom from './common'
import router from '@/router/index'
import avatar from '@/assets/loading.gif'

axios.defaults.timeout = 5 * 60 * 1000 // 超时响应 毫秒
axios.defaults.baseURL = publish.baseUrl // 根目录地址
// axios.defaults.withCredentials = true
axios.interceptors.request.use(
  config => {
    config.headers = {
      'Authorization': 'Bearer ' + window.localStorage.getItem('coeToken'),
      'Accept-Language': window.localStorage.getItem('language') || 'zh-CN'
    }
    if (config.url.indexOf('?') >= 0) {
      config.url = config.url + '&t=' + new Date().getTime()
    } else {
      config.url = config.url + '?t=' + new Date().getTime()
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)
function resetUrl (msg) {
  if (msg === '登陆无效' || msg === '登录无效') {
    // const redirUrl = window.location.href
    // window.location.href = publish.baseUrl + '/account/login?redirect=' + encodeURIComponent(redirUrl)
    localStorage.removeItem('coeToken')
    localStorage.removeItem('currMenu')
    // localStorage.removeItem('currentRole')
    window.location.href = publish.baseUrl + 'Home/login'
  } else if (msg === '用户不存在') {
    router.replace({
      name: 'noPermission'
    })
  } else {
    if (msg !== '很抱歉，您的访问权限等级不够，联系管理员!') {
      connom.alertTips({
        type: 'error',
        content: msg,
        stayTime: 5
      })
    }
  }
}
function noToken () {
  connom.alertTips({
    type: 'error',
    content: localStorage.language === 'zh-CN' ? '登录超时，正在跳转……' : 'Time out, redirecting……',
    stayTime: 5,
    isOnlyOne: true
  })
  // this.refreshToken(window.localStorage.getItem('coeToken'))
  localStorage.removeItem('coeToken')
  localStorage.removeItem('currMenu')
  // localStorage.removeItem('currentRole')
  window.location.href = publish.baseUrl + 'Home/login'
}
function noPermission () {
  // router.replace({
  //   name: 'noPermission'
  // })
}
export default {
  get (url, noloading) {
    return new Promise((resolve, reject) => {
      coverGif()
      axios.get(url)
        .then(response => {
          if (!noloading) {
            disCover()
          }
          if (response.data.success) {
            resolve(response.data)
          } else {
            resetUrl(response.data.message)
          }
        })
        .catch(err => {
          if (!noloading) {
            disCover()
          }
          if (err.response.status === 401) {
            noToken()
            return
          }
          if (err.response.status === 403) {
            noPermission()
          }
          connom.alertTips({
            type: 'error',
            content: localStorage.language === 'zh-CN' ? '服务异常' : 'Server Exception',
            stayTime: 5
          })
          reject(err)
        })
    })
  },
  post (url, data, noloading) {
    return new Promise((resolve, reject) => {
      coverGif()
      axios.post(url, data)
        .then(response => {
          if (!noloading) {
            disCover()
          }
          if (response.data.success) {
            resolve(response.data)
          } else {
            resetUrl(response.data.message)
          }
        })
        .catch(err => {
          if (!noloading) {
            disCover()
          }
          if (err.response.status === 401) {
            noToken()
            return
          }
          if (err.response.status === 403) {
            noPermission()
          }
          connom.alertTips({
            type: 'error',
            content: localStorage.language === 'zh-CN' ? '服务异常' : 'Server Exception',
            stayTime: 5
          })
          reject(err)
        })
    })
  },
  put (url, data) {
    return new Promise((resolve, reject) => {
      coverGif()
      axios.put(url, data)
        .then(response => {
          disCover()
          if (response.data.success) {
            resolve(response.data)
          } else {
            resetUrl(response.data.message)
          }
        })
        .catch(err => {
          disCover()
          if (err.response.status === 401) {
            noToken()
            return
          }
          if (err.response.status === 403) {
            noPermission()
          }
          connom.alertTips({
            type: 'error',
            content: localStorage.language === 'zh-CN' ? '服务异常' : 'Server Exception',
            stayTime: 5
          })
          reject(err)
        })
    })
  },
  del (url) {
    return new Promise((resolve, reject) => {
      coverGif()
      axios.delete(url)
        .then(response => {
          disCover()
          if (response.data.success) {
            resolve(response.data)
          } else {
            resetUrl(response.data.message)
          }
        })
        .catch(err => {
          disCover()
          if (err.response.status === 401) {
            noToken()
            return
          }
          if (err.response.status === 403) {
            noPermission()
          }
          connom.alertTips({
            type: 'error',
            content: localStorage.language === 'zh-CN' ? '服务异常' : 'Server Exception',
            stayTime: 5
          })
          reject(err)
        })
    })
  },
  delete (url, data, noloading) {
    return new Promise((resolve, reject) => {
      coverGif()
      axios.delete(url, data)
        .then(response => {
          if (!noloading) {
            disCover()
          }
          if (response.data.success) {
            resolve(response.data)
          } else {
            resetUrl(response.data.message)
          }
        })
        .catch(err => {
          disCover()
          if (err.response.status === 401) {
            noToken()
            return
          }
          if (err.response.status === 403) {
            noPermission()
          }
          connom.alertTips({
            type: 'error',
            content: localStorage.language === 'zh-CN' ? '服务异常' : 'Server Exception',
            stayTime: 5
          })
          reject(err)
        })
    })
  },
  upLoad (url, data) {
    return new Promise((resolve, reject) => {
      coverGif()
      axios({
        method: 'put',
        url: url,
        data: data,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(response => {
        disCover()
        if (response.data) {
          resolve(response.data)
        } else {
          resetUrl(response.data.message)
        }
      }).catch(err => {
        disCover()
        if (err.response.status === 401) {
          noToken()
          return
        }
        if (err.response.status === 403) {
          noPermission()
        }
        connom.alertTips({
          type: 'error',
          content: localStorage.language === 'zh-CN' ? '服务异常' : 'Server Exception',
          stayTime: 5
        })
        reject(err)
      })
    })
  },
  refreshToken (token) {
    axios.get(publish.baseUrl + 'api/login/refreshToken?token=' + token).then(msg => {
      window.localStorage.setItem('coeToken', msg.data.data.token)
      window.location.reload()
    }).catch(err => {
      window.localStorage.setItem('coeToken', '')
      connom.alertTips({
        type: 'error',
        content: '登录异常，请重新登录',
        stayTime: 5
      })
      window.location.reload()
      return err
    })
  }
}
function coverGif () {
  if (!document.getElementById('loadingGif')) {
    let dom = document.createElement('div')
    dom.id = 'loadingGif'
    let html = '<img src="' + avatar + '" height="200" width="200" style="opacity: 0.5"/>'
    dom.innerHTML = html
    dom.style.userSelect = 'none'
    document.getElementById('app').appendChild(dom)
  }
}
function disCover () {
  if (document.getElementById('loadingGif')) {
    document.getElementById('app').removeChild(document.getElementById('loadingGif'))
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/axios.js